'use strict'
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod }
  }
Object.defineProperty(exports, '__esModule', { value: true })
var createIcon_1 = __importDefault(require('./../createIcon'))
exports.default = createIcon_1.default('la la-external-link-alt')
//# sourceMappingURL=ExternalLinkAltIcon.js.map
